<div
   class="modal-header p-0"
   style="justify-content: end; margin-top: -5px; margin-bottom: 5px">
   <button
      type="button"
      class="btn-close position-static"
      data-bs-dismiss="modal"
      aria-label="Close"
      style="padding-bottom: 4px"
      (click)="onClose()">
      <span aria-hidden="true">×</span>
   </button>
</div>
<div
   class="modal-body p-0"
   style="padding-left: 20px !important; padding-right: 20px !important">
   <div class="coverPageContainer">
      <h3 style="text-align: center; font-weight: 700">2025 Pricing Update</h3>

      <div
         class="section"
         style="margin-top: 20px">
         <p>
            Over the past several years, pricing has been a difficult process for the veterinary industry and our practices. COVID-19 disruption,
            rapid spikes in inflation, challenges in the labor market, fierce competition from e-tailers on products, and aggressive vendor cost
            increases have driven the need for significant and frequent price increases.
         </p>

         <p>
            We redesigned our pricing process in 2024 significantly. In 2025, we are building on our strong foundation from last year and continuing
            to improve for the long-term by:
         </p>

         <ul style="list-style: disc; padding-inline-start: 40px">
            <li>Allows for a single increase in services pricing this year</li>
            <li>Uses data and analytics to calculate pricing specifically tailored to each practice</li>
            <li>Provides the ability to immediately execute price changes in our PIMS</li>
         </ul>

         <p>
            This document outlines the key factors considered in building individualized prices specific to your practice and provides information
            about how to participate in the pricing process.
         </p>
      </div>

      <div
         class="section"
         style="text-align: center">
         <div class="box">
            <table style="margin-left: auto; margin-right: auto">
               <tr>
                  <td
                     colspan="3"
                     style="padding-bottom: 15px; text-decoration: underline; text-align: center">
                     <b>Here are some of the factors we considered in your custom pricing</b>
                  </td>
               </tr>
               <tr>
                  <td style="vertical-align: top">
                     <b>Your practice statistics:</b>
                     <ul style="list-style: disc; padding-inline-start: 15px">
                        <li>
                           Annual revenue:
                           {{ activeCycle()?.annualRevenue | currency }}
                        </li>
                        <li>
                           Total visits:
                           {{ activeCycle()?.totalVisits ?? "No data available" }}
                        </li>
                        <li>
                           Existing clients:
                           {{ activeCycle()?.totalExistingClients ?? "No data available" }}
                        </li>
                        <li>
                           New clients:
                           {{ activeCycle()?.totalNewClients ?? "No data available" }}
                        </li>
                        <li>Pets: {{ activeCycle()?.pets ?? "No data available" }}</li>
                        <li>
                           Median days to book:
                           {{ activeCycle()?.medianDaysToBook ?? "No data available" }}
                        </li>
                     </ul>
                  </td>

                  <td style="vertical-align: top; padding-left: 60px">
                     <b>Your customer characteristics:</b>
                     <ul style="list-style: disc; padding-inline-start: 15px">
                        <li>
                           Customer median income:
                           {{ activeCycle()?.clientMedianIncome | currency }}
                        </li>
                        <li>
                           Average drive time:
                           {{ activeCycle()?.medianDriveTime }} minutes
                        </li>
                     </ul>
                  </td>

                  <td style="vertical-align: top; padding-left: 60px">
                     <b>Your market characteristics:</b>
                     <ul style="list-style: disc; padding-inline-start: 15px">
                        <li>Urbanicity: {{ activeCycle()?.urbanicity }}</li>
                        <li>Practice type: {{ activeCycle()?.practiceTypeName }}</li>
                     </ul>
                  </td>
               </tr>
            </table>
         </div>
      </div>

      <div class="section key-dates">
         <table style="margin-left: auto; margin-right: auto">
            <tr>
               <td
                  colspan="4"
                  style="padding-bottom: 15px; text-decoration: underline; text-align: center">
                  <b>Key dates for your practice</b>
               </td>
            </tr>
            <tr>
               <td style="vertical-align: top">
                  <ul>
                     <li>
                        <b>Deadline to sign up for 1:1 reviews:</b>
                        <br />
                        {{ activeCycle()?.deadlineToSignup | date : "EEEE, MMMM d" }}{{ getDaySuffix(activeCycle()?.deadlineToSignup) }}, 11:59PM ET
                     </li>
                  </ul>
               </td>

               <td style="vertical-align: top; padding-left: 40px">
                  <ul>
                     <li>
                        <b>1:1 discussion available:</b>
                        <br />
                        {{ activeCycle()?.discussionAvailable | date : "EEEE, MMMM d" }}{{ getDaySuffix(activeCycle()?.discussionAvailable) }} -
                        {{ activeCycle()?.discussionComplete | date : "EEEE, MMMM d" }}{{ getDaySuffix(activeCycle()?.discussionComplete) }}
                     </li>
                  </ul>
               </td>

               <td style="vertical-align: top; padding-left: 40px">
                  <ul>
                     <li>
                        <b>Pricing pushed to your PIMS with updates:</b>
                        <br />
                        {{ activeCycle()?.scheduledFor | date : "EEEE, MMMM d" }}{{ getDaySuffix(activeCycle()?.scheduledFor) }}, 9:00PM ET
                     </li>
                  </ul>
               </td>

               <td style="vertical-align: top; padding-left: 40px">
                  <ul>
                     <li>
                        <b>Pricing pushed to your PIMS with NO updates:</b>
                        <br />
                        {{ activeCycle()?.discussionAvailable | date : "EEEE, MMMM d" }}{{ getDaySuffix(activeCycle()?.discussionAvailable) }}, 9:00PM ET
                     </li>
                  </ul>
               </td>
            </tr>
         </table>
      </div>

      <div class="section">
         <ng-container *ngIf="!!pricingCaptain">
            <p style="font-weight: 700; text-decoration: underline">
               Your pricing partner is {{ pricingCaptain().firstName }}
               {{ pricingCaptain().lastName }}
            </p>
            <p>
               Please move to the next page to see your updated price suggestions. This will allow you to update any product or service price, and
               allow you to select a date and time to meet with your partner.
            </p>
         </ng-container>

         <p>
            If you do not have any pricing feedback and wish to keep your prices the same, click the "Approve all and Submit" button on the next page.
            Your pricing will automatically be implemented on
            <strong>
               <!--{{ activeCycle()?.scheduledFor | date:'EEEE, MMMM d' }}{{
									getDaySuffix(activeCycle()?.scheduledFor) }}-->
               {{ activeCycle()?.discussionAvailable | date : "EEEE, MMMM d" }}{{ getDaySuffix(activeCycle()?.discussionAvailable) }}, 9:00PM ET
            </strong>
            .
         </p>

         <p class="footer">Please note, your regional manager won't be able to help with practice-specific pricing questions.</p>
      </div>

      <div class="section">
         <p style="font-weight: 700; text-decoration: underline">Logistics for price adjustments</p>
         <p>
            Our new tools will safely backup and update pricing within your PIMS. If you have questions, please be sure to schedule time with your
            pricing partner before
            <strong>11:59PM ET on {{ activeCycle()?.deadlineToSignup | date : "EEEE, MMMM d" }}{{ getDaySuffix(activeCycle()?.deadlineToSignup) }}</strong>
            .
         </p>
      </div>
   </div>
</div>
